

const types = new Map();

function defineType(item) {
    types.set(item.id.toUpperCase(), item)
}

const sessionLogItemTypes = {

    SessionPause: 'sessionPause',
    SessionRecording: 'sessionRecording',
    SessionComplete: 'sessionComplete',

    ProtocolStepChanged: 'protocolStepChanged',
    DeviceError: 'deviceError',

    SessionMark: 'sessionMark',
    SessionMarkNumber: 'sessionMarkNumber',
    SessionMarkLactate: 'sessionMarkLactate',
    SessionMarkRPE: 'sessionMarkRPE',
    SessionMarkSPO2: 'sessionMarkSPO2',

    SessionDevicesChanged: 'sessionDevicesChanged',
    SessionBindDevice: 'sessionBindDevice',
    SessionUnBindDevice: 'sessionUnBindDevice',
    SessionScanStart: 'sessionScanStart',
    SessionScanStop: 'sessionScanStop',

    TrainerAutoSync: 'trainerAutoSync',

    CategoryMark: 'mark',
    CategoryProtocol: 'protocol',
    CategorySession: 'session',
    CategoryDevice: 'device',
    CategoryOther: 'other',

    getCategories() {
        return [
            {label: 'Marks', value: this.CategoryMark},
            {label: 'Protocol Changes', value: this.CategoryProtocol},
            {label: 'Session Changes', value: this.CategorySession},
            {label: 'VO2 Device Events', value: this.CategoryDevice},
            {label: 'Other', value: this.CategoryOther},
        ];
    },

    find(type) {
        let found = types.get(type.toUpperCase());
        return found ?? {
            id: type,
            label: type,
            color: '#1b82c9',
        };
    }
};

let idx = 0;

defineType({
    id: sessionLogItemTypes.SessionRecording, order: idx++,
    label: 'Recording', color: '#20b306', icon: 'fa-play',
    category: sessionLogItemTypes.CategorySession
});
defineType({
    id: sessionLogItemTypes.SessionPause, order: idx++,
    label: 'Paused', color: '#f1a501', icon: 'fa-pause',
    category: sessionLogItemTypes.CategorySession
});
defineType({
    id: sessionLogItemTypes.SessionComplete, order: idx++,
    label: 'Completed', color: '#1b82c9', icon: 'fa-check',
    category: sessionLogItemTypes.CategorySession
});

defineType({
    id: sessionLogItemTypes.DeviceError, order: idx++,
    label: 'VO2 Device', color: '#d50566', icon: 'fa-exclamation-triangle',
    category: sessionLogItemTypes.CategoryDevice
});
defineType({
    id: sessionLogItemTypes.ProtocolStepChanged, order: idx++,
    label: 'Step Changed', color: '#1b82c9', icon: 'fa-forward',
    category: sessionLogItemTypes.CategoryProtocol
});

defineType({
    id: sessionLogItemTypes.SessionMark, order: idx++,
    label: 'Mark', color: '#420dd2', icon: 'fa-flag',
    category: sessionLogItemTypes.CategoryMark
});
defineType({
    id: sessionLogItemTypes.SessionMarkNumber, order: idx++,
    label: 'Mark', color: '#6f0121', icon: 'fa-clipboard',
    category: sessionLogItemTypes.CategoryMark
});
defineType({
    id: sessionLogItemTypes.SessionMarkLactate, order: idx++,
    label: 'Lactate', color: '#b86711', icon: 'fa-clipboard',
    category: sessionLogItemTypes.CategoryMark
});
defineType({
    id: sessionLogItemTypes.SessionMarkRPE, order: idx++,
    label: 'RPE', color: '#059ad5', icon: 'fa-clipboard',
    category: sessionLogItemTypes.CategoryMark
});
defineType({
    id: sessionLogItemTypes.SessionMarkSPO2, order: idx++,
    label: 'SPO2', color: '#04a56d', icon: 'fa-clipboard',
    category: sessionLogItemTypes.CategoryMark
});
defineType({
    id: sessionLogItemTypes.TrainerAutoSync, order: idx++,
    label: 'Trainer AutoSync', color: '#636262', icon: 'fa-clipboard',
    category: sessionLogItemTypes.CategorySession
});


export default sessionLogItemTypes
